module.exports = __webpack_public_path__ + "banner4.725fcffe1fe171d00be7.png";